<template>
  <div class="about">
    <!--回到顶部-->
    <el-backtop title="回到页面顶部" target=".about" :visibility-height="200" :right="40" :bottom="150"><i class="el-icon-arrow-up"></i></el-backtop>
    <div class="about-info">
      <el-card class="card" body-style="display: flex; flex-direction: row; padding: 10px">
          <div class="web-info">
            <div class="info-title" style="text-align: center; ">
              <span style="font-size: 30px; font-weight: bold">{{ title }}</span>
            </div>
            <div class="info-line"><span style="text-align: center; color: red; ">{{ webDescription }}</span></div>
            <div class="info-line"><el-tag style="margin-right: 10px;">邮箱</el-tag>{{ email }}</div>
          </div>
          <div>
            <el-divider direction="vertical"></el-divider>
          </div>
          <div class="tech-info">
            <div class="info-title"><span style="font-size: 20px;">{{ webInfo }}</span></div>
            <div class="info-line">
              <el-tag style="margin-right: 10px;">服务端</el-tag>{{ serverInfo }}
            </div>
            <div class="info-line">
              <el-tag type="success" style="margin-right: 10px;">网页端</el-tag>{{ browserInfo }}
            </div>
          </div>
        </el-card>
    </div>
    <div style="margin: 10px">
      <span>更新记录</span>
    </div>
    <div class="update-log">
      <div class="log">
        <el-timeline reverse>
          <el-timeline-item v-for="(item, index) in updateLog" :key="index" :timestamp="item.time" placement="top">
            <el-card class="card" body-style="padding:0 20px 10px 20px">
              <h4>{{item.title}}</h4>
              <p style="margin: 10px 0" v-for="(item1, index2) in item.content.split(' ')" :key="index2">
                {{item1}}
              </p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <el-divider direction="horizontal" content-position="center">我也是有底线的╭(╯^╰)╮</el-divider>
    </div>

  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      title: '我的音乐',
      webDescription: '仅供学习使用，切勿用于其他用途',
      webInfo: '网站使用前后端分离进行开发',
      email: '2450283110@qq.com',
      serverInfo: 'SSM + MySQL + Maven',
      browserInfo: 'Vue2 + VueRouter + Vuex + ElementUI + Axios + Less + vueAPlayer',
      updateLog: [
        {
          time: '20230712',
          title: '完成了搜索页面功能： ',
          content: '1、搜索 ' +
              '2、播放 ' +
              '3、歌单的查询、创建 ' +
              '4、添加歌曲到歌单 '
        },
        {
          time: '20230713',
          title: '完成了音乐列表页面功能： ',
          content: '1、歌单列表展示、添加、删除 ' +
              '2、歌单不同模式播放 ' +
              '3、添加歌曲到播放列表 ' +
              '4、播放器的控制（vueAPlayer有好多bug） ' +
              '5、播放列表的展示 ' +
              '6、一些其他bug '
        },
        {
          time: '20230715',
          title: '修复bug，添加功能： ',
          content: '1、修复页面显示问题 ' +
              '2、添加一些小功能 '
        },
      ]
    }
  },

}
</script>

<style lang="less" scoped>
.about {
  /*background: url("../../assets/imgs/about-bg.jpg") fixed;*/
  /*background-size:100% 100%;*/
  /*要使用el-backTop需要设置的两个属性*/
  height: 100%;
  overflow-x: hidden;

  display: flex;
  flex-direction: column;

  .about-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px;


    .web-info {
      padding: 20px;
    }

    // 分割线
    .el-divider--vertical {
      height: 100%;
      margin: 0;
    }

    .tech-info {
      padding: 20px;
    }
  }

  .update-log {
    // 添加上可实现局部滚动
    //overflow-y: scroll;

    .log {
      margin: 0 40px 0 0;

    }

    // 分割线
    .el-divider--horizontal {
      height: 2px;
      margin: 0;
    }
  }


}

.card {
  /*opacity: 0.8;*/
}

.info-title {
  line-height: 60px;
  margin: 10px;
}
.info-line {
  line-height: 40px;
  margin: 10px;
}
</style>
